module.exports = __webpack_public_path__ + "ico_new_folder-61ce209d53f5751d5d4e4176aac8433a.png";